import React, { useEffect, useRef } from 'react';

import { View, StyleSheet } from 'react-native';
import { setExpenseValue } from '../../store/actions/expense';
import { useDispatch, useSelector } from 'react-redux';

import { selectExpenseStates } from '../../store/selectors/expense.selector';
import { getAddress, transformGoogleAddress } from '../../utils/directions.util';

import { EXPENSE_ACTION_TYPES } from '../../constants/Enums';
import { DynamoDBFieldNames } from '../../constants/ExpenseCategories';

const ExpenseCar = ({
  stepOneForm,
  stepOneContinueButton,
  isCreationForm,
  isEditable = true,
  subTab,
}) => {
  const dispatch = useDispatch();
  const actionType = isCreationForm ? EXPENSE_ACTION_TYPES.CREATION : EXPENSE_ACTION_TYPES.UPDATE;
  const expenseStates = useSelector(selectExpenseStates)[actionType][subTab];
  const isFirstRender = useRef(true);

  useEffect(() => {
    const setPickUpDropOffLabelsAndCalculateDistance = async () => {
      const pickUpLabel = expenseStates[DynamoDBFieldNames.MILEAGE_LOCATION_FROM];
      const dropOffLabel = expenseStates[DynamoDBFieldNames.MILEAGE_LOCATION_TO];
      let pickUpLat, pickUpLong, dropOffLat, dropOffLong;
      if (pickUpLabel) {
        const pickUpAddress = await getAddress(pickUpLabel);
        const pickUpLocationDetails = await transformGoogleAddress(pickUpAddress);
        ({ latitude: pickUpLat, longitude: pickUpLong } = pickUpLocationDetails);
      }
      if (dropOffLabel) {
        const dropOffAddress = await getAddress(dropOffLabel);
        const dropOffLocationDetails = await transformGoogleAddress(dropOffAddress);
        ({ latitude: dropOffLat, longitude: dropOffLong } = dropOffLocationDetails);
      }
      if (pickUpLat && pickUpLong && dropOffLat && dropOffLong) {
        const distance = calculateDistanceBetween2LatLng(
          { lat: pickUpLat, lng: pickUpLong },
          { lat: dropOffLat, lng: dropOffLong }
        );
        if (distance) {
          dispatch(
            setExpenseValue({
              actionType,
              subTab,
              key: DynamoDBFieldNames.DISTANCE,
              value: distance,
            })
          );
        }
      }
    };
    // Skip execution on the first render so it doesn't overwrite the existing expense value
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    if (isEditable) {
      setPickUpDropOffLabelsAndCalculateDistance();
    }
  }, [
    expenseStates[DynamoDBFieldNames.MILEAGE_LOCATION_FROM],
    expenseStates[DynamoDBFieldNames.MILEAGE_LOCATION_TO],
  ]);

  const calculateDistanceBetween2LatLng = (latLngFrom, latLngTo) => {
    const radiusMiles = 3958.8; // Radius of the Earth in miles
    const degrees = 180;

    const radiansLatFrom = latLngFrom.lat * (Math.PI / degrees); // Convert degrees to radians
    const radiansLatTo = latLngTo.lat * (Math.PI / degrees); // Convert degrees to radians
    const difflat = radiansLatTo - radiansLatFrom; // Radian difference (latitudes)
    const difflon = (latLngTo.lng - latLngFrom.lng) * (Math.PI / degrees); // Radian difference (longitudes)

    return (
      2 *
      radiusMiles *
      Math.asin(
        Math.sqrt(
          Math.sin(difflat / 2) * Math.sin(difflat / 2) +
            Math.cos(radiansLatFrom) *
              Math.cos(radiansLatTo) *
              Math.sin(difflon / 2) *
              Math.sin(difflon / 2)
        )
      )
    ).toFixed(2);
  };

  return (
    <View style={styles.container}>
      {stepOneForm}
      {isCreationForm ? stepOneContinueButton : null}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
});

export default ExpenseCar;
